// SPDX-License-Identifier: FSL-1.1-Apache-2.0
import type React from "react";
import { cx } from "./cx";

export interface FadeInProps extends React.HTMLAttributes<HTMLDivElement> {
  delay?: number;
}

export function FadeIn({
  children,
  className,
  delay = 0,
  style,
  ...props
}: FadeInProps): React.ReactElement {
  const mergedStyle =
    delay > 0 ? { ...style, transitionDelay: `${delay}ms` } : style;

  return (
    <div
      {...props}
      className={cx("gn-analytics-motion__fade-in", className)}
      style={mergedStyle}
    >
      {children}
    </div>
  );
}
